/**
 * Retrieves a cookie value by name
 * @param {string} name - The name of the cookie
 * @returns {string|null} The cookie value or null if not found
 */
export function getCookie(name) {
    if (!document.cookie) {
        return null;
    }

    const cookies = document.cookie.split(';');
    const prefix = `${name}=`;

    for (const cookie of cookies) {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith(prefix)) {
            return decodeURIComponent(trimmedCookie.substring(prefix.length));
        }
    }

    return null;
}

export function showToast(message, type) {
    htmx.trigger(document, 'toast:add', {
        message: message,
        type: type
    });
}
